import { z } from "zod/v4";
import { fetchApi, fetchVoid } from "./internal";

export const directory = {
	federations: () =>
		fetchApi("/public/directory/federations", z.object({ items: z.array(z.any()) })),
	federation: (slug: string) => fetchApi(`/public/directory/federations/${slug}`, z.any()),
	clubs: (federation?: string, limit = 50, offset = 0) => {
		const params = new URLSearchParams({
			limit: limit.toString(),
			offset: offset.toString(),
		});
		if (federation) params.set("federation", federation);
		return fetchApi(
			`/public/directory/clubs?${params.toString()}`,
			z.object({
				items: z.array(z.any()),
				total: z.number(),
				limit: z.number(),
				offset: z.number(),
			}),
		);
	},
	syncClubs: () =>
		fetchApi("/admin/directory/clubs/sync", z.object({ inserted: z.number() }), { method: "POST" }),
	setClubWebsite: (slug: string, website: string) =>
		fetchVoid(`/admin/directory/clubs/${slug}/website`, {
			method: "PUT",
			body: JSON.stringify({ website }),
		}),
	setClubLogo: (slug: string, logoUrl: string) =>
		fetchVoid(`/admin/directory/clubs/${slug}/logo`, {
			method: "PUT",
			body: JSON.stringify({ logo_url: logoUrl }),
		}),
	enrichWebsites: () =>
		fetchApi(
			"/admin/directory/clubs/websites",
			z.object({
				status: z.string().optional(),
				candidates: z.number().optional(),
				found: z.number().optional(),
			}),
			{ method: "POST" },
		),
	enrichLogos: () =>
		fetchApi("/admin/directory/clubs/logos", z.object({ enriched: z.number() }), {
			method: "POST",
		}),
};
